export default __webpack_public_path__ + "static/media/KFAS_Logo.b78f2f8c.png";